export default __webpack_public_path__ + "static/media/spacing-top.6e384a53.svg";